import React, { useState, useEffect, useRef  } from "react";
import axios from "axios";
import "./CategoryForm.css";

const CategoryForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    location: "",
    rating: "",
    reviews: "",
    description: "",
    price: "",
    promotion: "",
    image: null, // Changed from string to null for file handling
    category: "",
    subcategory: "",
    services: [],
    openServices: false,
  });

  const [categories, setCategories] = useState([]);
  const [catagory, setcatagory] = useState([]);
  const [selectedCollection, setSelectedCollection] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const [imagePreview, setImagePreview] = useState(""); // For showing preview of selected image

  useEffect(() => {
    fetchCategories();
    fetchcatagory();
  }, []);

  const API_URL = process.env.REACT_APP_API_URL;
  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${API_URL}/categories`);
      const vendorSubcategories = res.data
        .filter(cat => cat.category === "Vendors")
        .flatMap(cat => Array.isArray(cat.subcategory) ? cat.subcategory : []);
      
      const normalized = res.data.map(cat => ({
        ...cat,
        subcategory: Array.isArray(cat.subcategory)
          ? cat.subcategory
          : cat.subcategory
          ? [cat.subcategory]
          : [],
        services: vendorSubcategories,
      }));
      
      setCategories(normalized);
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  const fetchcatagory = async () => {
    try {
      const res = await axios.get(`${API_URL}/catagory`);
      setcatagory(res.data);
    } catch (err) {
      console.error("Error fetching catagory:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    // Create preview URL
    const previewUrl = URL.createObjectURL(file);
    setImagePreview(previewUrl);
    
    // Update form data with the File object
    setFormData(prev => ({
      ...prev,
      image: file
    }));
  }
};

const handleEdit = (collection) => {
  setFormData({
    ...collection,
    services: Array.isArray(collection.services)
      ? collection.services
      : collection.services
      ? [collection.services]
      : [],
    openServices: false,
    image: null // Reset file input but keep preview of existing image
  });
  
  // Set image preview if there's an existing image
  if (collection.image) {
    setImagePreview(`${API_URL}/catagory${collection.image}`);
  } else {
    setImagePreview("");
  }
  
  setEditingId(collection._id);
};

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      category: value,
      subcategory: "",
      services: [],
    }));
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;
    try {
      await axios.delete(`${API_URL}/catagory${id}`);
      setcatagory((prev) => prev.filter((item) => item._id !== id));
    } catch (err) {
      console.error("Error deleting category:", err);
      alert("Failed to delete. Please try again.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const formDataToSend = new FormData();
      
      // Append all form fields to FormData
      Object.keys(formData).forEach(key => {
        if (key === 'services') {
          // Handle array fields
          formData[key].forEach(service => {
            formDataToSend.append('services', service);
          });
        } else if (key !== 'openServices') {
          formDataToSend.append(key, formData[key]);
        }
      });

      if (editingId) {
        // Update existing category
        await axios.put(`${API_URL}/catagory${editingId}`, formDataToSend, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        setMessage("Collection updated successfully!");
      } else {
        // Create new category
        await axios.post(`${API_URL}/catagory`, formDataToSend, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        setMessage("Collection added successfully!");
      }
      
      setError(false);
      resetForm();
      fetchcatagory();
    } catch (err) {
      setMessage(
        "Error saving collection: " +
          (err.response?.data?.error || err.message)
      );
      setError(true);
    }
  };

  const resetForm = () => {
    setFormData({
      name: "",
      location: "",
      rating: "",
      reviews: "",
      description: "",
      price: "",
      promotion: "",
      image: null,
      category: "",
      subcategory: "",
      services: [],
      openServices: false,
    });
    setEditingId(null);
    setImagePreview("");
  };



  const handleView = (collection) => {
    setSelectedCollection(collection);
  };

  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setFormData((prev) => ({ ...prev, openServices: false }));
      }
    }
    function handleEscape(event) {
      if (event.key === "Escape") {
        setFormData((prev) => ({ ...prev, openServices: false }));
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [setFormData]);
  return (
    <div className="category-form-container">
      <h2 >{editingId ? "Edit Collection" : "Add New Category Collection"}</h2>

      {message && (
        <p className={`category-form-message ${error ? "error" : "success"}`}>
          {message}
        </p>
      )}

      {/* Image Upload */}
      <div className="image-upload-section">
        <label>Image:</label>
        <input 
          type="file" 
          accept="image/*" 
              multiple 
          onChange={handleImageChange}
        />
        {imagePreview && (
          <div className="image-preview">
            <img 
              src={imagePreview} 
              alt="Preview" 
              style={{ maxWidth: '200px', maxHeight: '200px', marginTop: '10px' }}
            />
          </div>
        )}
      </div>

      {/* Category Dropdown */}
      <div className="category-dropdown">
        <label>Choose Category:</label>
        <select
          name="category"
          value={formData.category}
          onChange={handleCategoryChange}
        >
          <option value="">-- Select Category --</option>
          {categories.map((cat) => (
            <option key={cat._id} value={cat.category}>
              {cat.category}
            </option>
          ))}
        </select>
      </div>

      {/* Subcategory Dropdown */}
      {formData.category && (
        <div className="subcategory-dropdown">
          <label>Choose Subcategory:</label>
          <select
            name="subcategory"
            value={formData.subcategory}
            onChange={handleChange}
          >
            <option value="">-- Select Subcategory --</option>
            {categories
              .find((cat) => cat.category === formData.category)
              ?.subcategory.map((sub, idx) => (
                <option key={idx} value={sub}>
                  {sub}
                </option>
              ))}
          </select>
        </div>
      )}

      {/* Services Dropdown */}
    {formData.category && (
      <div className="services-dropdown" style={{ position: "relative" }} ref={dropdownRef}>
        <label>Choose Services:</label>
        <div
          className="dropdown-box"
          onClick={() =>
            setFormData((prev) => ({
              ...prev,
              openServices: !prev.openServices,
            }))
          }
          style={{
            border: "1px solid #ccc",
            padding: "8px",
            cursor: "pointer",
            minWidth: "200px",
            background: "white",
          }}
        >
          {formData.services && formData.services.length > 0
            ? formData.services.join(", ")
            : "Select Services"}
        </div>
        {formData.openServices && (
          <div
            className="dropdown-options"
            style={{
              border: "1px solid #ccc",
              marginTop: "4px",
              maxHeight: "150px",
              overflowY: "auto",
              background: "white",
              position: "absolute",
              zIndex: 1000,
              width: "100%",
            }}
          >
            {categories
              .find((cat) => cat.category === formData.category)
              ?.services.map((service, idx) => (
                <label key={idx} style={{ display: "block", padding: "4px" }}>
                  <input
                    type="checkbox"
                    checked={formData.services.includes(service)}
                    onChange={() => {
                      const isSelected = formData.services.includes(service);
                      setFormData((prev) => ({
                        ...prev,
                        services: isSelected
                          ? prev.services.filter((s) => s !== service)
                          : [...prev.services, service],
                      }));
                    }}
                  />
                  {service}
                </label>
              ))}
            {/* Optional Done button to close the dropdown */}
            <button
              type="button"
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  openServices: false,
                }))
              }
              style={{
                margin: "4px 0 4px 4px",
                padding: "4px 10px",
                cursor: "pointer",
              }}
            >
              Done
            </button>
          </div>
        )}
      </div>
    )
}

      {/* Form */}
      <form onSubmit={handleSubmit} className="category-form">
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          
        />
        <input
          type="text"
          name="location"
          placeholder="Location"
          value={formData.location}
          onChange={handleChange}
          
        />
        <input
          type="number"
          name="rating"
          placeholder="Rating"
          value={formData.rating}
          onChange={handleChange}
          min="0"
          max="5"
          step="0.1"
        />
        <input
          type="number"
          name="reviews"
          placeholder="Reviews"
          value={formData.reviews}
          onChange={handleChange}
          min="0"
        />
        <input
          type="number"
          name="price"
          placeholder="Price"
          value={formData.price}
          onChange={handleChange}
          min="0"
        />
        <textarea
          name="description"
          placeholder="Description"
          value={formData.description}
          onChange={handleChange}
    
        ></textarea>
        <button type="submit">
          {editingId ? "Update Collection" : "Add Collection"}
        </button>
      </form>

      {/* View Section */}
      {selectedCollection && (
        <div className="view-details">
          <h3>Collection Details</h3>
          {selectedCollection.image && (
            <div className="collection-image">
              <img 
                src={`${API_URL}/catagory${selectedCollection.image}`} 
                alt={selectedCollection.name}
                style={{ maxWidth: '200px', maxHeight: '200px' }}
              />
            </div>
          )}
          <p>
            <strong>Name:</strong> {selectedCollection.name}
          </p>
          <p>
            <strong>Category:</strong> {selectedCollection.category}
          </p>
          <p>
            <strong>Subcategory:</strong> {selectedCollection.subcategory}
          </p>
          <p>
            <strong>Description:</strong> {selectedCollection.description}
          </p>
          <p>
            <strong>Price:</strong> ₹{selectedCollection.price || "N/A"}
          </p>
        </div>
      )}

      {/* Table */}
      <h3>All catagory</h3>
      <table className="category-table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Category</th>
            <th>Subcategory</th>
            <th>Service</th>
            <th>Route</th>
            <th>Price</th>
            <th>Reviews</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {catagory.map((col) => (
            <tr key={col._id}>
              <td>
                {col.image && (
                  <img 
                    src={`${API_URL}/catagory${col.image}`} 
                    alt={col.name}
                    style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                  />
                )}
              </td>
              <td>{col.category}</td>
              <td>{col.subcategory}</td>
              <td>{Array.isArray(col.services) ? col.services.join(", ") : col.services}</td>
              <td>{col.location}</td>
              <td>₹{col.price || "N/A"}</td>
              <td>{col.rating} ({col.reviews} reviews)</td>
              <td>
                <button onClick={() => handleView(col)}>View</button>
                <button onClick={() => handleEdit(col)}>Edit</button>
                <button onClick={() => handleDelete(col._id)}>Delete</button>
              </td>
            </tr>
          ))}
          {catagory.length === 0 && (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                No catagory found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CategoryForm;